import { SagaIterator } from 'redux-saga';
import {  select } from 'redux-saga/effects';

import { openBlankWindow } from '~src/spacesPlatform/sagas/SpacesSagaHelpers';

import { SessionSiteSelectors } from '../../app/selectors/SessionInfoSelectors';
import { ContentActionsService } from '../../commonInfra/contentActions/ContentActions';
import { NewPredictiveModelForDatasourceAction } from '../entityActions/NewPredictiveModelForDatasourceAction';

export function* handleNewPredictiveModelForDatasourceAction(action: NewPredictiveModelForDatasourceAction): SagaIterator {
  const newWindow: Window = openBlankWindow();
  const siteUrlName: string = yield select(SessionSiteSelectors.siteUrlName);
  newWindow.location.href = ContentActionsService.predictiveModelEditorUrl(siteUrlName);
}

